/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { ApplicationTypeViewModel } from "../../features/application-type/application-type-viewmodel"
import { useViewModel } from "../app/app-hooks"
import { ApplicationTypeRowView } from "../application-type/application-type-row-view"

interface ApplicationTypeSelectorTableProps {
    selectedIds: number[]
    setSelectedIds: (ids: number[]) => void
}

export const ApplicationTypeSelectorTable = ({ selectedIds, setSelectedIds }: ApplicationTypeSelectorTableProps) => {
    const appTypeVM = useViewModel(ApplicationTypeViewModel)
    const appTypes = appTypeVM.allAppTypes

    const toggleSelection = (id: number) => {
        const current = selectedIds
        const updated = current.includes(id) ? current.filter((existingId) => existingId !== id) : [...current, id]

        setSelectedIds(updated)
    }

    const handleSelectAll = () => {
        const allIds = appTypes.map((type) => type.id).filter((id): id is number => typeof id === "number")
        setSelectedIds(allIds)
    }

    const handleDeselectAll = () => {
        setSelectedIds([])
    }

    return (
        <div className="mt-1">
            <div className="mb-2">Application type assignment.</div>

            {appTypes.length > 0 && (
                <div className="flex gap-2 mb-2 me-1">
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleSelectAll}>
                        Select All
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleDeselectAll}>
                        Deselect All
                    </button>
                </div>
            )}

            <table className="table table-sm">
                <tbody>
                    {appTypes.map((appType) => {
                        const selected = selectedIds.includes(appType.id ?? -1)
                        return (
                            <ApplicationTypeRowView
                                appType={appType}
                                selected={selected}
                                selectable={true}
                                onClick={() => appType.id !== undefined && toggleSelection(appType.id)}
                                key={appType.id ?? 0}
                            />
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
